import React from 'react';
import App from 'App';
// import paths, { rootPaths } from './paths';
import paths, { rootPaths } from './newPaths';


import { Navigate, createBrowserRouter } from 'react-router-dom';

import MainLayout from 'layouts/MainLayout';
import Alfa from 'features-csvc/i_info/Alfa';
import Beta from 'features-csvc/i_info/Beta';
import Gamma from 'features-csvc/i_info/Gamma';

import GeneralHome from 'features-csvc/components-csvc/GeneralHome'
import Questionario from 'features-csvc/components-csvc/Questionario'

import Presentazione from 'features-csvc/p_welcome/Presentazione';

import PartnerPerIniziare from 'features-csvc/i_info/PartnerPerIniziare';
import AziendaPerIniziare from 'features-csvc/i_info/AziendaPerIniziare';


import FaseA from 'features-csvc/c_metodologia/FaseA';
import FaseB from 'features-csvc/c_metodologia/FaseB';
import FaseC from 'features-csvc/c_metodologia/FaseC';
import Output from 'features-csvc/c_metodologia/Output';

import Scheda01 from 'features-csvc/c_metodologia/Scheda01';
import Scheda02 from 'features-csvc/c_metodologia/Scheda02';
import Scheda03 from 'features-csvc/c_metodologia/Scheda03';
import Scheda04 from 'features-csvc/c_metodologia/Scheda04';
import Scheda05 from 'features-csvc/c_metodologia/Scheda05';
import Scheda06 from 'features-csvc/c_metodologia/Scheda06';
import Scheda07 from 'features-csvc/c_metodologia/Scheda07';
import Scheda08 from 'features-csvc/c_metodologia/Scheda08';
import Scheda09 from 'features-csvc/c_metodologia/Scheda09';
import Scheda10 from 'features-csvc/c_metodologia/Scheda10';

import Scheda11 from 'features-csvc/c_metodologia/Scheda11';
import Scheda12 from 'features-csvc/c_metodologia/Scheda12';
import Scheda13 from 'features-csvc/c_metodologia/Scheda13';
import Scheda14 from 'features-csvc/c_metodologia/Scheda14';
import Scheda15 from 'features-csvc/c_metodologia/Scheda15';
import Scheda16 from 'features-csvc/c_metodologia/Scheda16';
import Scheda17 from 'features-csvc/c_metodologia/Scheda17';

import AnalisiStrategica from 'features-csvc/d_datiGeneraliQuestionario/AnalisiStrategica';
import SelezioneStakeholder from 'features-csvc/d_datiGeneraliQuestionario/SelezioneStakeholder';
import SelezioneAmbiti from 'features-csvc/d_datiGeneraliQuestionario/SelezioneAmbiti';
import SelezioneAnni from 'features-csvc/d_datiGeneraliQuestionario/SelezioneAnni';
import IdentificazioneRischiEtMitigazioni from 'features-csvc/d_datiGeneraliQuestionario/IdentificazioneRischiEtMitigazioni';
import ValutazioneRilevanzaRischiEtMitigazioni from 'features-csvc/d_datiGeneraliQuestionario/ValutazioneRilevanzaRischiEtMitigazioni';

import CompilaQuestionarioAmbito from 'features-csvc/e_compilazioneAmbiti/CompilaQuestionarioAmbito';
import RiepilogoQuestionario from 'features-csvc/f_output/RiepilogoQuestionario';
import DoppiaMatriceMaterialita from 'features-csvc/f_output/DoppiaMatriceMaterialita';
import ValoreAggiuntoRiattribuito from 'features-csvc/f_output/ValoreAggiuntoRiattribuito';
import ValoreAggiuntoStakeholderComuni from 'features-csvc/f_output/ValoreAggiuntoStakeholderComuni';
import InputContoEconomico from 'features-csvc/f_output/InputContoEconomico';


import ErrorLayout from 'layouts/ErrorLayout';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

export const csvcRoutes = createBrowserRouter([
    {
        element: <App />,
        children: [
          {
            path: rootPaths.errorsRoot,
            element: <ErrorLayout />,
            children: [
              {
                path: paths.error404,
                element: <Error404 />
              },
              {
                path: paths.error500,
                element: <Error500 />
              }
            ]
          },
          {
            path: 'app/',
            element: <MainLayout />,
            children: [
              {
                index: true,
                element: <GeneralHome />
              },
              {
                path: 'info/alfa',
                element: <Alfa />  
              },
              {
                path: 'info/beta',
                element: <Beta />  
              },
              {
                path: 'info/gamma',
                element: <Gamma />  
              },
              {
                path: 'info/partner-per-iniziare',
                element: <PartnerPerIniziare />  
              },           
              {
                path: 'info/azienda-per-iniziare',
                element: <AziendaPerIniziare />  
              },           
              {
                path: 'welcome/presentazione',
                element: <Presentazione />  
              },
              {
                path: 'metodologia/fase-a',
                element: <FaseA />  
              },
              {
                path: 'metodologia/fase-b',
                element: <FaseB />  
              },
              {
                path: 'metodologia/fase-c',
                element: <FaseC />  
              },
              {
                path: 'metodologia/output',
                element: <Output />  
              },

              {
                path: 'metodologia/fase-a/scheda-01',
                element: <Scheda01 />  
              },
              {
                path: 'metodologia/fase-a/scheda-02',
                element: <Scheda02 />  
              },
              {
                path: 'metodologia/fase-a/scheda-03',
                element: <Scheda03 />  
              },
              {
                path: 'metodologia/fase-a/scheda-04',
                element: <Scheda04 />  
              },
              {
                path: 'metodologia/fase-a/scheda-05',
                element: <Scheda05 />  
              },
              {
                path: 'metodologia/fase-a/scheda-06',
                element: <Scheda06 />  
              },

              {
                path: 'metodologia/fase-b/scheda-07',
                element: <Scheda07 />  
              },
              {
                path: 'metodologia/fase-b/scheda-08',
                element: <Scheda08 />  
              },
              {
                path: 'metodologia/fase-b/scheda-09',
                element: <Scheda09 />  
              },

              {
                path: 'metodologia/fase-c/scheda-10',
                element: <Scheda10 />  
              },
              {
                path: 'metodologia/fase-c/scheda-11',
                element: <Scheda11 />  
              },
              {
                path: 'metodologia/fase-c/scheda-12',
                element: <Scheda12 />  
              },

              {
                path: 'metodologia/output/scheda-13',
                element: <Scheda13 />  
              },
              {
                path: 'metodologia/output/scheda-14',
                element: <Scheda14 />  
              },

              {
                path: 'metodologia/output/scheda-15',
                element: <Scheda15 />  
              },

              {
                path: 'metodologia/output/scheda-16',
                element: <Scheda16 />  
              },

              {
                path: 'metodologia/output/scheda-17',
                element: <Scheda17 />  
              },

              {
                path: 'questionario',
                element: <Questionario />  
              },
              {
                path: 'questionario/analisi-strategica',
                element: <AnalisiStrategica />  
              },
              {
                path: 'questionario/selezione-stakeholder',
                element: <SelezioneStakeholder />  
              },
              {
                path: 'questionario/selezione-ambiti',
                element: <SelezioneAmbiti />  
              },
              {
                path: 'questionario/selezione-anni',
                element: <SelezioneAnni />  
              },
              {
                path: 'questionario/identificazione-rischi-e-mitigazioni',
                element: <IdentificazioneRischiEtMitigazioni />  
              },
              {
                path: 'questionario/valutazione-rilevanza-rischi-e-mitigazioni',
                element: <ValutazioneRilevanzaRischiEtMitigazioni />  
              },
              {
                path: paths.compilaQuestionarioAmbito(':ambitoCsvcCodice'),
                element: <CompilaQuestionarioAmbito />  
              },
              {
                path: 'questionario/riepilogo',
                element: <RiepilogoQuestionario />  
              },
              {
                path: 'questionario/doppia-matrice-materialita',
                element: <DoppiaMatriceMaterialita />  
              },
              {
                path: 'questionario/valore-aggiunto-riattribuito',
                element: <ValoreAggiuntoRiattribuito />  
              },
              {
                path: 'questionario/valore-aggiunto-stakeholder-comuni',
                element: <ValoreAggiuntoStakeholderComuni />  
              },
              {
                path: 'questionario/input-conto-economico',
                element: <InputContoEconomico />  
              },
              {
                path: '*',
                element: <Navigate to={paths.error404} replace />
              }    
            ]
          }
        ]
    }
  ]
);
